import React from 'react';
import { currentUser, badges } from '../utils/mockData';
import { AwardIcon, TrophyIcon, StarIcon } from 'lucide-react';
const StudentAchievementsPage: React.FC = () => {
  // Get earned badges
  const earnedBadges = badges.filter(badge => currentUser.badges.includes(badge.id));
  const unearnedBadges = badges.filter(badge => !currentUser.badges.includes(badge.id));
  return <div className="max-w-5xl mx-auto" data-id="element-884">
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-885">我的积分和勋章</h1>
      <div className="bg-white rounded-lg shadow p-6 mb-8" data-id="element-886">
        <div className="flex items-center" data-id="element-887">
          <div className="p-4 bg-blue-100 rounded-full mr-6" data-id="element-888">
            <TrophyIcon size={32} className="text-blue-600" data-id="element-889" />
          </div>
          <div data-id="element-890">
            <h2 className="text-xl font-medium text-gray-800" data-id="element-891">当前积分</h2>
            <p className="text-3xl font-bold text-blue-600 mt-1" data-id="element-892">
              {currentUser.points}
            </p>
          </div>
          <div className="ml-auto text-right" data-id="element-893">
            <p className="text-sm text-gray-500" data-id="element-894">
              继续完成学习目标来获取更多积分！
            </p>
            <p className="text-sm text-gray-500 mt-1" data-id="element-895">
              获得勋章也可以增加积分哦
            </p>
          </div>
        </div>
      </div>
      <div className="mb-8" data-id="element-896">
        <div className="flex justify-between items-center mb-4" data-id="element-897">
          <h2 className="text-xl font-medium text-gray-800" data-id="element-898">已获得的勋章</h2>
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-899">
            {earnedBadges.length} / {badges.length}
          </span>
        </div>
        {earnedBadges.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-900">
            {earnedBadges.map(badge => <div key={badge.id} className="bg-white rounded-lg shadow p-6 text-center" data-id="element-901">
                <div className="text-4xl mb-4" data-id="element-902">{badge.icon}</div>
                <h3 className="font-medium text-gray-800 mb-2" data-id="element-903">{badge.name}</h3>
                <p className="text-gray-600 text-sm mb-3" data-id="element-904">
                  {badge.description}
                </p>
                <div className="inline-flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm" data-id="element-905">
                  <StarIcon size={14} className="mr-1" data-id="element-906" />
                  {badge.pointsValue} 积分
                </div>
              </div>)}
          </div> : <div className="bg-white rounded-lg shadow p-8 text-center" data-id="element-907">
            <p className="text-gray-600" data-id="element-908">你还没有获得勋章，继续努力！</p>
          </div>}
      </div>
      {unearnedBadges.length > 0 && <div data-id="element-909">
          <h2 className="text-xl font-medium text-gray-800 mb-4" data-id="element-910">
            可获得的勋章
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-911">
            {unearnedBadges.map(badge => <div key={badge.id} className="bg-white rounded-lg shadow p-6 text-center opacity-60" data-id="element-912">
                <div className="text-4xl mb-4" data-id="element-913">{badge.icon}</div>
                <h3 className="font-medium text-gray-800 mb-2" data-id="element-914">{badge.name}</h3>
                <p className="text-gray-600 text-sm mb-3" data-id="element-915">
                  {badge.description}
                </p>
                <div className="inline-flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm" data-id="element-916">
                  <StarIcon size={14} className="mr-1" data-id="element-917" />
                  {badge.pointsValue} 积分
                </div>
              </div>)}
          </div>
        </div>}
      <div className="mt-8 bg-white rounded-lg shadow p-6" data-id="element-918">
        <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-919">积分历史记录</h2>
        <div className="overflow-x-auto" data-id="element-920">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-921">
            <thead data-id="element-922">
              <tr data-id="element-923">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-924">
                  日期
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-925">
                  活动
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-926">
                  积分变化
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-927">
              <tr data-id="element-928">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-929">
                  2023-11-15
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" data-id="element-930">
                  完成"背诵50个高频雅思词汇"目标
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-931">
                  +50
                </td>
              </tr>
              <tr data-id="element-932">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-933">
                  2023-11-05
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" data-id="element-934">
                  获得"学习起步"勋章
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-935">
                  +50
                </td>
              </tr>
              <tr data-id="element-936">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-937">
                  2023-10-30
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" data-id="element-938">
                  完成"完成数学练习册第二章"目标
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-939">
                  +30
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default StudentAchievementsPage;